/**
 * Created by Tiger on 04/03/2022.
 */
import Types from '../types';


export function onChangeTab(tabKey) {
  return dispatch => {
    localStorage.setItem('currentTabKey', tabKey)
    dispatch({ type: Types.CHANGED_HEADER_TAB, currentTabKey: tabKey });
  };
}
